// Confirmación de caída a 0% al soltar sobre la zona de descarte (2026-09-26, ver
// docs/modulos/pizarra-ventas.md "Zona de descarte — caída a 0%"). Presentacional puro, mismo
// molde que ConfirmarCierre100Modal (reactstrap Modal/ModalHeader/ModalBody/ModalFooter) pero
// SIEMPRE singular — a diferencia del 100%, la caída a 0% mueve SOLO la propuesta arrastrada,
// nunca el grupo del cliente (ver el comentario de `handleDropSobre0` en index.js) — no recibe
// `items`, recibe los datos ya resueltos de una sola propuesta. Sobrio a propósito: sin festejo,
// sin `dispararFestejo`, ningún color de alerta — es un registro, no una advertencia. NO pide
// motivo de pérdida (el campo no existe todavía, lo está definiendo la conversación del modelo de
// oportunidad) — nada en este componente asume que ese campo vaya a aparecer.
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

/**
 * @param {{
 *   isOpen: boolean,
 *   nombreCliente: string,
 *   campana: string,
 *   monto: string,
 *   onCancel: () => void,
 *   onConfirm: () => void,
 * }} props
 */
export const ConfirmarCaidaModal = ({ isOpen, nombreCliente, campana, monto, onCancel, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>Marcar como caída</ModalHeader>
      <ModalBody>
        <p>
          <strong>{nombreCliente}</strong> — {campana} — {monto}
        </p>
        <p className="text-muted" style={{ fontSize: "0.85rem", marginBottom: 0 }}>
          Pasa a 0% y desaparece de la Pizarra — no se borra, queda como registro. Para recuperarla, andá a Detalle.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          Cancelar
        </Button>
        <Button color="primary" onClick={onConfirm}>
          Confirmar
        </Button>
      </ModalFooter>
    </Modal>
  );
};
